import {
  buildServices
} from './utils/build_services'
import buildParamList from './utils/build_params'
import omitBy from 'lodash.omitby'
import isEmpty from 'lodash.isempty'
import {
  adaptVideosToStore,
  adaptVideoToApi,
  adaptVideoToStore
} from './adapters/videoAdapter'
import { VIDEOS } from '@/services/axios.config'

const services = [
  {
    name: 'listVideos',
    method: 'get',
    url: (params) => `/videos${buildParamList(omitBy(params, isEmpty))}`,
    resolver: adaptVideosToStore
  },
  {
    name: 'getVideo',
    method: 'get',
    url: (params) => `/videos/${params.videoId}`,
    resolver: adaptVideoToStore
  },
  {
    name: 'createVideo',
    method: 'post',
    url: () => `/videos`,
    data: (params) => {
      return adaptVideoToApi(params)
    },
    resolver: adaptVideoToStore
  },
  {
    name: 'editVideo',
    method: 'patch',
    url: (params) => `/videos/${params.videoId}`,
    data: (params) => {
      return adaptVideoToApi(params)
    },
    resolver: adaptVideoToStore
  },
]

export const {
  listVideos,
  getVideo,
  editVideo,
  createVideo,
} = buildServices(VIDEOS, services)